var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJpWorkplace({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "outline/briefcase"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.12841 4.82051C7.12841 3.26279 8.39119 2 9.94892 2H14.0515C15.6092 2 16.872 3.26279 16.872 4.82051V6.10256H19.1797C20.7374 6.10256 22.0002 7.36535 22.0002 8.92308V14.2952C22.0005 14.3071 22.0005 14.319 22.0002 14.3308V19.1795C22.0002 20.7372 20.7374 22 19.1797 22H4.82072C3.26299 22 2.0002 20.7372 2.0002 19.1795V14.3306C1.99993 14.3189 1.99993 14.3071 2.0002 14.2954V8.92308C2.0002 7.36535 3.26299 6.10256 4.82072 6.10256H7.12841V4.82051ZM4.82072 7.64103C4.11266 7.64103 3.53867 8.21502 3.53867 8.92308V13.7887C6.1674 14.7867 9.01912 15.3333 12.0002 15.3333C14.9813 15.3333 17.833 14.7867 20.4617 13.7887V8.92308C20.4617 8.21502 19.8877 7.64103 19.1797 7.64103H4.82072ZM15.3335 6.10256H8.66687V4.82051C8.66687 4.11246 9.24086 3.53846 9.94892 3.53846H14.0515C14.7595 3.53846 15.3335 4.11246 15.3335 4.82051V6.10256ZM20.4617 15.4271C17.8143 16.3629 14.9659 16.8718 12.0002 16.8718C9.03447 16.8718 6.18611 16.3629 3.53867 15.4271V19.1795C3.53867 19.8875 4.11266 20.4615 4.82072 20.4615H19.1797C19.8877 20.4615 20.4617 19.8875 20.4617 19.1795V15.4271ZM11.231 13.0256C11.231 12.6008 11.5754 12.2564 12.0002 12.2564H12.0105C12.4353 12.2564 12.7797 12.6008 12.7797 13.0256C12.7797 13.4505 12.4353 13.7949 12.0105 13.7949H12.0002C11.5754 13.7949 11.231 13.4505 11.231 13.0256Z",
    fill: "#70758F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJpWorkplace);
export default __webpack_public_path__ + "static/media/jp-workplace.3ef86c00b3e49cb2476cbaab5009ce50.svg";
export { ForwardRef as ReactComponent };